<template>
  <img v-if="asset" class="badge" :src="asset" :alt="badge.name" :title="badge.name" />
  <svg v-else class="badge" viewBox="0 0 24 24" :style="{ color: badge.color }" :aria-label="badge.name" role="img" focusable="false">
    <title>{{ badge.name }}</title>
    <path v-for="(path, i) in paths" :key="i" :d="path" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" />
  </svg>
</template>
<script>
import badgePaths from '../badge-paths'
export default {
  props: { badge: { type: Object, required: true } },
  computed: {
    paths() { return badgePaths[this.badge.id] || [] },
    asset() {
      const assets = {
        staff: 'discord-staff.svg', partner: 'discord-partner.svg',
        hypesquad_events: 'hype-squad-events.svg', bravery: 'hype-squad-bravery.svg',
        brilliance: 'hype-squad-brilliance.svg', balance: 'hype-squad-balance.svg',
        bug_hunter: 'discord-bug-hunter-green.svg', bug_hunter_gold: 'discord-bug-hunter-gold.svg',
        early_supporter: 'discord-early-supporter.svg', early_verified_developer: 'discord-bot-dev.svg',
        active_developer: 'active-developer.svg', moderator_alumni: 'discord-mod.svg',
        nitro: 'discord-nitro.svg', orbs: 'orb.svg'
      }
      return assets[this.badge.id] ? `/badges/${assets[this.badge.id]}` : ''
    }
  }
}
</script>
